import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import _ from "lodash";
import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables";

// Css
import "../../assets/css/grantaccesstables.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    adminNameHeader: "Admin Name",
    adminEmailHeader: "Admin Email",
    selectAdminBtn: "Select Admin",
    editAdminBtn: "Edit Admin",
    popUpTitle: "Admins",
    selectAdminsLabel: "Select Admins",
    nameHeader: "Name",
    emailHeader: "Email",
    adminListLabel: "Admin List",
    okBtn: "OK",
    cancelBtn: "Cancel",
    noDataTitle: "There is no data to display",
    selectAdmin: "Please select at least one admin",
  },
  ja: {
    adminNameHeader: "副管理者名",
    adminEmailHeader: "副管理者Email",
    selectAdminBtn: "副管理者選択",
    editAdminBtn: "副管理者編集",
    popUpTitle: "副管理者",
    selectAdminsLabel: "副管理者選択",
    nameHeader: "名前",
    emailHeader: "Eメール",
    adminListLabel: "副管理者リスト",
    okBtn: "OK",
    cancelBtn: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    selectAdmin: "少なくとも 1 人の管理者を選択してください",
  },
  es: {
    adminNameHeader: "Nombre del Administrador",
    adminEmailHeader: "Correo Electrónico del Administrador",
    selectAdminBtn: "Seleccionar Administrador",
    editAdminBtn: "Editar Administrador",
    popUpTitle: "Administradores",
    selectAdminsLabel: "Seleccionar Administradores",
    nameHeader: "Nombre",
    emailHeader: "Correo Electrónico",
    adminListLabel: "Lista de Administradores",
    okBtn: "Aceptar",
    cancelBtn: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    selectAdmin: "Por favor seleccione al menos un administrador",
  },
});

class AdminsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
      adminListArray: [],
      addedAdmins: [],
      selectedAdmins: [],
      emptyArray: [],
      selectedAdminsCounter: 0,
      limitApproval: 0,
      _notificationSystem: null,
    };

    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this
    );
    this.renderSelectAdmin = this.renderSelectAdmin.bind(this);
    this.unselectAdmin = this.unselectAdmin.bind(this);
    this.handlePopupSubmit = this.handlePopupSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    // Get max multi approval from super admin subscribtion details
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            // console.log(eachSuperAdmin.val());
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;
            let maxMulti;

            if (eachSuperAdminDetails.payment !== undefined) {
              if (eachSuperAdminDetails.payment.maxMulti !== undefined) {
                maxMulti = eachSuperAdminDetails.payment.maxMulti;
              }
            }

            for (const member in members) {
              if (members[member].memberEmail === auth.currentUser.email) {
                this.setState({
                  limitApproval: maxMulti,
                });
              }
            }
          });
        }
      });
  }

  createCustomInsertButton = (onClick) => {
    return (
      <button
        className="selectAdminBtn"
        onClick={() => this.handleInsertButtonClick(onClick)}
      >
        <i className="fa fa-user" />{" "}
        {this.state.selectedAdmins.length > 0
          ? localizationStrings.editAdminBtn
          : localizationStrings.selectAdminBtn}
      </button>
    );
  };

  handleInsertButtonClick() {
    const allAdmins = [];
    const addedAdminsEmail = [];
    const selectedAdmins = [];

    // console.log(this.props.adminList);

    for (var i = 0; i < this.state.addedAdmins.length; i++) {
      const eachAddedAdminEmail = this.state.addedAdmins[i].adminEmail;

      addedAdminsEmail.push(eachAddedAdminEmail);
    }

    for (var a = 0; a < this.props.adminList.length; a++) {
      const eachAdmin = this.props.adminList[a];

      if (!addedAdminsEmail.includes(eachAdmin.adminEmail)) {
        allAdmins.push(eachAdmin);
      }
    }

    for (var b = 0; b < this.props.selectedAdmins.length; b++) {
      const eachSelectedAdmin = this.props.selectedAdmins[b];

      selectedAdmins.push(eachSelectedAdmin);
    }

    this.setState({
      showPopup: true,
      adminListArray: allAdmins,
      selectedAdmins: selectedAdmins,
    });
  }

  handlePopupClose() {
    const addedAdminArray = [];

    for (var i = 0; i < this.state.selectedAdmins.length; i++) {
      const eachSelectedAdmin = this.state.selectedAdmins[i];

      addedAdminArray.push(eachSelectedAdmin);
    }

    this.setState({
      showPopup: false,
      addedAdmins: addedAdminArray,
    });
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder="Search"
      />
    );
  }

  renderSelectAdmin(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            if (this.state.selectedAdminsCounter < this.state.limitApproval) {
              const allAdminsArrayList = this.state.adminListArray;
              const addedAdminsArrayList = this.state.addedAdmins;

              addedAdminsArrayList.push(row);
              allAdminsArrayList.splice(allAdminsArrayList.indexOf(row), 1);

              this.setState({
                adminListArray: allAdminsArrayList,
                addedAdmins: addedAdminsArrayList,
                selectedAdminsCounter: addedAdminsArrayList.length,
              });
            }
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectAdmin(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allAdminsArrayList = this.state.adminListArray;
            const addedAdminsArrayList = this.state.addedAdmins;

            allAdminsArrayList.push(row);
            addedAdminsArrayList.splice(addedAdminsArrayList.indexOf(row), 1);

            this.setState({
              adminListArray: allAdminsArrayList,
              addedAdmins: addedAdminsArrayList,
              selectedAdminsCounter: addedAdminsArrayList.length,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  handlePopupSubmit() {
    if (this.state.addedAdmins.length <= 0) {
      this.showNotification(`${localizationStrings.selectAdmin}`, "error", 5);
      return;
    }

    const confirmedAdmins = [];

    for (var i = 0; i < this.state.addedAdmins.length; i++) {
      const eachAddedAdmin = this.state.addedAdmins[i];

      confirmedAdmins.push(eachAddedAdmin);
    }

    this.props.dataCallBack(confirmedAdmins);

    this.setState({
      showPopup: false,
      selectedAdmins: confirmedAdmins,
    });
  }

  conditionRenderingMultiData() {
    if (this.state.selectedAdmins.length >= this.state.limitApproval) {
      return this.state.emptyArray;
    } else {
      return this.state.adminListArray;
    }
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }

    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        {this.props.visible && (
          <BootstrapTable
            data={this.state.selectedAdmins}
            bordered={false}
            pagination
            options={{
              sizePerPage: 5,
              hideSizePerPage: true,
              insertBtn: this.createCustomInsertButton,
              noDataText: localizationStrings.noDataTitle,
            }}
            insertRow
            tableStyle={{ border: "4px solid #3C3E41", borderRadius: "12px" }}
          >
            <TableHeaderColumn
              dataField="adminName"
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.adminNameHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="adminEmail"
              isKey={true}
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.adminEmailHeader}
            </TableHeaderColumn>
          </BootstrapTable>
        )}
        {/* //! Popup for Select Admin Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.popUpTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <div className="selectMembersTable">
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.selectAdminsLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.conditionRenderingMultiData()}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  searchField: this.createCustomSearchFieldForm,
                  defaultSortName: "adminName", // default sort column name
                  defaultSortOrder: "asc", // default sort order
                  noDataText: localizationStrings.noDataTitle,
                }}
                search
              >
                <TableHeaderColumn
                  // dataSort
                  dataField="adminName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="adminEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.renderSelectAdmin}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.adminListLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.addedAdmins}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  noDataText: localizationStrings.noDataTitle,
                }}
              >
                <TableHeaderColumn
                  // dataSort
                  dataField="adminName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="adminEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.unselectAdmin}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
            </div>
            <FormGroup style={{ display: "flex" }}>
              <Button
                style={{ marginRight: "10px" }}
                onClick={this.handlePopupSubmit}
              >
                {localizationStrings.okBtn}
              </Button>
              <Button
                style={{ marginLeft: "10px" }}
                onClick={this.handlePopupClose}
              >
                {localizationStrings.cancelBtn}
              </Button>
            </FormGroup>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default AdminsTable;
